import React, { Fragment, useState } from "react";
import { Flex } from "@100mslive/roomkit-react";
import { SettingsIcon } from "@100mslive/react-icons";
import SettingsModal from "../Settings/SettingsModal";
import { AudioVideoToggle } from "../AudioVideoToggle";
import IconButton from "../../IconButton";
import { VirtualBackground } from "../../plugins/VirtualBackground/VirtualBackground";

const PreviewSettings = React.memo(() => {
  const [open, setOpen] = useState(false);
  return (
    <Fragment>
      {/* If Host */}
      <IconButton
        data-testid="preview_setting_btn"
        onClick={() => setOpen(value => !value)}
        style={{
          backgroundColor: "#FFFFFF",
          color: "#2B3340",
          border: "1px solid #E3E8EE",
          padding: 12,
          width: 48,
          height: 48,
        }}
      >
        <SettingsIcon />
      </IconButton>
      {open && <SettingsModal open={open} onOpenChange={setOpen} />}
    </Fragment>
  );
});

export const PreviewControls = ({
  isVirtualOfficePreview = false,
  enableVideoToggle = true,
  enabledColor = "white",
  settingsAsFirstOption = false,
}) => {
  return (
    <Flex
      gap="2"
      css={{
        marginRight: "8px",
      }}
    >
      {settingsAsFirstOption && <PreviewSettings />}
      <Flex css={{ gap: "$4" }}>
        <AudioVideoToggle
          compact
          inPreview={true}
          inVirtualOfficePreview={isVirtualOfficePreview}
          enableVideoToggle={enableVideoToggle}
          enabledColor={enabledColor}
        />
        <VirtualBackground />
      </Flex>
      {!settingsAsFirstOption && <PreviewSettings />}
    </Flex>
  );
};

export default PreviewControls;
